import { Language } from '@graphics/gfx-common/dist/constants'
import { User } from '@graphics/gfx-common/dist/types'
import { ITypeaheadObject, ISelectInput } from './pack'

export enum types {
  SAVE_PREFERENCE__STARTED = 'SAVE_PREFERENCE__STARTED',
  SAVE_PREFERENCE__SUCCESS = 'SAVE_PREFERENCE__SUCCESS',
  GET_PREFERENCES__STARTED = 'GET_PREFERENCES__STARTED',
  GET_PREFERENCES__SUCCESS = 'GET_PREFERENCES__SUCCESS',
  GET_PREFERENCES__FAILURE = 'GET_PREFERENCES__FAILURE',
  DELETE_PREFERENCE__STARTED = 'DELETE_PREFERENCE__STARTED',
  DELETE_PREFERENCE__SUCCESS = 'DELETE_PREFERENCE__SUCCESS',
}

export interface ISavePreferenceAction {
  type: types.SAVE_PREFERENCE__STARTED
  groupId: string
  fieldName: string
  fieldValue: any
  updateMode: boolean
}

export interface ISavePreferenceSuccessAction {
  type: types.SAVE_PREFERENCE__SUCCESS
  groupId: string
  preferenceData: ITransformedPreferenceResponseData
}

export interface IGetPreferencesAction {
  type: types.GET_PREFERENCES__STARTED
}

export interface IGetPreferencesSuccessAction {
  type: types.GET_PREFERENCES__SUCCESS
  userGroupsPreferences: IUserGroupsPreferences
}

export interface IGetPreferencesFailureAction {
  type: types.GET_PREFERENCES__FAILURE
}

export interface IDeletePreferenceAction {
  type: types.DELETE_PREFERENCE__STARTED
  groupId: string
  fieldName: string
}

export interface IDeletePreferenceSuccessAction {
  type: types.DELETE_PREFERENCE__SUCCESS
  groupId: string
  fieldName: string
}

export type UserPreferencesActionsType =
  | ISavePreferenceAction
  | ISavePreferenceSuccessAction
  | IGetPreferencesAction
  | IGetPreferencesSuccessAction
  | IGetPreferencesFailureAction
  | IDeletePreferenceAction
  | IDeletePreferenceSuccessAction

export interface ISavePreferenceRequestData {
  preferenceKey: string
  preferenceValue: string
}

export interface ISavePreferenceResponseData
  extends ISavePreferenceRequestData {
  createTimestamp: string
}

export interface IGetPreferenceResponseData
  extends ISavePreferenceResponseData {
  updateTimestamp: string
}

export interface ITransformedPreferenceResponseData {
  fieldName: string
  fieldValue: any
}

export interface IUserGroupPreferences {
  title?: string
  description?: string
  byline?: string
  language?: Language | ''
  location?: ITypeaheadObject
  contacts?: User[]
  slugline?: string
  tags?: ISelectInput[]
  topiccodes?: ITypeaheadObject[]
}

export interface IUserGroupsPreferences {
  [key: string]: IUserGroupPreferences
}

export interface IUserPreferences {
  isLoading: boolean
  isLoaded: boolean
  byGroup: IUserGroupsPreferences
}
